import moment from "moment";

export const prices = {
  default: '$69',
  defaultDetailed: '$69.00',
}

const Jessica = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/jessica.png";
const Haley = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/haley.png";

export const getDistributedRatings = (fiveStarRatings: number) => {
  const ratingsObject: { [key: number]: number } = {
    5: Math.round(fiveStarRatings * 0.7),
    4: Math.round(fiveStarRatings * 0.15),
    3: Math.round(fiveStarRatings * 0.1),
    2: Math.round(fiveStarRatings * 0.05),
    1: Math.round(fiveStarRatings * 0.0)
  };

  return ratingsObject;
};

export const checkoutUrl = "https://ceroface.checkout-x.com/f/5JRDHVK9/c/n/32758281666691:1";

export const staticRating = 4.8;

export const staticTestimonialHero = {
  reviewTitle: "MY NEW FAV!",
  reviewRating: 5,
  avatar: Jessica,
  author: "Jessica W.",
  reviewMessage:
    `I'm pleasantly surprised by how well this works! For only ${prices.default} this extracts EVERYTHING without leaving a mark. For the first time I’ve been getting compliments on my skin, feels unreal, thank you!!`,
  reviewDate: moment().subtract(3, "days"),
  location: 'US'
};

export const staticTestimonialCta = {
  reviewTitle: "Put skepticism aside",
  reviewRating: 5,
  avatar: Haley,
  author: "Haley M.",
  reviewMessage:
    "I've been using it once a week for 2 weeks now. I mostly get blackheads and clogged pores around my nose and this has finally cleared it up for me! It sucks up all the blackheads and oil. After using, large pores have shrunk in size and each pore is clean! Good purchase!",
  reviewDate: moment().subtract(2, "days"),
  location: 'CA'
};
